import { useEffect } from "react";
import { Controller } from "react-hook-form";
import {
  MotifInput,
  MotifSelect,
  MotifOption,
  MotifProgressLoader,
  MotifErrorMessage,
} from "@ey-xd/motif-react";
import { useGetDropDownListQuery } from "@/services/advanceSearch/advanceSearchReducer";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";

type ValueElementProps = {
  index: number;
  groupIndex?: number;
  control: any;
  treeRows: any[];
  disable?: boolean;
};

const ValueElement = ({
  index,
  groupIndex,
  control,
  treeRows,
  disable,
}: ValueElementProps) => {
  let { caseId } = useParams();
  const {t}=useTranslation()
  const path =
    groupIndex !== undefined
      ? `treeRows.${index}.treeRows.${groupIndex}`
      : `treeRows.${index}`;
  const attributeType =
    groupIndex !== undefined
      ? treeRows[index]?.treeRows[groupIndex]?.attributeType
      : treeRows[index]?.attributeType;
  const attributeDefinitionId =
    groupIndex !== undefined
      ? treeRows[index]?.treeRows[groupIndex]?.propertyName
      : treeRows[index]?.propertyName;
  const dropDownApiEndpoint =
    groupIndex !== undefined
      ? treeRows[index]?.treeRows[groupIndex]?.apiEndpoint
      : treeRows[index]?.apiEndpoint;
        
  const {
    data: attributeOperatorsData,
    isFetching,
    isSuccess,
    isError
  } = useGetDropDownListQuery(
    dropDownApiEndpoint!=="Search/ListCustomAttributeValues"
      ? { caseId: caseId, apiEndpoint: dropDownApiEndpoint }
      : {
          attributeDefinitionId: attributeDefinitionId,
          apiEndpoint: dropDownApiEndpoint
            ? dropDownApiEndpoint
            : "Search/ListCustomAttributeValues",
        },
    {
      skip: ![5, 4]?.includes(attributeType) && !dropDownApiEndpoint,
    }
  );
  let dropDownArray: any[] = [];

  if (attributeOperatorsData && Array.isArray(attributeOperatorsData)) {
    attributeOperatorsData?.forEach((option: string, ind: number) => {
      dropDownArray.push(
        <MotifOption
          key={`${attributeDefinitionId}-${index}-${ind}`}
          value={option}
          title={option}
        >
          {option}
        </MotifOption>
      );
    });
  } else if (attributeOperatorsData && isSuccess) {
    let dropDownJson = { ...attributeOperatorsData };
    dropDownArray = Object?.keys(dropDownJson)?.map((key) => {
      return (
        <MotifOption
          key={`${attributeDefinitionId}-${index}-${key}`}
          value={key}
          title={dropDownJson[key]}
        >
          {dropDownJson[key]}
        </MotifOption>
      );
    });
  }
  useEffect(() => {
    const btn = document.querySelectorAll(
      ".motif-select-input"
    ) as NodeListOf<Element>;
    btn.forEach((element: Element) => {
      if (attributeType === 3 || attributeType === 4 || attributeType === 5) {
        (element as HTMLElement).setAttribute("type", "button");
      }
    });
  }, [attributeType]);

  function handleMotifSelectValue(value: any): any {
    if (!attributeOperatorsData) return undefined;
    if (attributeType === 5) {
      if (!value) return [];
      return value?.toString().split(",");
    } else if (attributeType === 4) {
      return value?.toString() || undefined;
    }
    return undefined;
  }
  return (
    <Controller
      name={`${path}.value`}
      control={control}
      rules={{ required: "Value is required" }}
      render={({ field, fieldState: { error } }) => {
        switch (attributeType) {
          case 1:
            return (
              <MotifInput
                //@ts-ignore
                type="number"
                onChange={field.onChange}
                value={field.value}
                hideClearButton={true}
                disabled={disable}
              />
            );
          case 2:
            return (
              <MotifInput
                //@ts-ignore
                type="date"
                hideClearButton={true}
                onChange={field.onChange}
                value={field.value}
                disabled={disable}
              />
            );
          case 3:
            return (
              <MotifSelect
                onChange={field.onChange}
                value={field.value ? field.value.toString() : ""}
                placeholder="Select"
                disabled={disable}
              >
                <MotifOption value="True">True</MotifOption>
                <MotifOption value="False">False</MotifOption>
              </MotifSelect>
            );
          case 4:
          case 5:
            return (
              <div style={{ position: "relative" }}>
                <MotifSelect
                  key={`${attributeDefinitionId}-${index}`}
                  id={attributeDefinitionId}
                  onChange={(e: any) => {
                    attributeType === 5
                      ? field.onChange(e?.toString())
                      : field.onChange(e);
                  }}
                  value={handleMotifSelectValue(field.value)}
                  placeholder="Select"
                  filter={dropDownArray.length > 5 ? true : false}
                  disabled={disable || isFetching}
                  multiple={attributeType === 5 ? true : false}
                >
                  {dropDownArray}
                </MotifSelect>
                {isFetching && (
                  <div
                    style={{
                      position: "absolute",
                      top: "22.5%",
                      right: "-22px",
                    }}
                  >
                    <MotifProgressLoader
                      variant="circular"
                      size="xs"
                    ></MotifProgressLoader>
                  </div>
                )}
                { isError &&  <MotifErrorMessage>{t("global.globalNotifications.wentWrong")}</MotifErrorMessage>}
              </div>
            );
          default:
            return (
              <MotifInput
                //@ts-ignore
                onChange={field.onChange}
                value={field.value}
                hideClearButton={true}
                disabled={disable}
              />
            );
        }
      }}
    />
  );
};

export default ValueElement;
